import { normalizeObjectDetailsResponse } from '@atlassian/jira-servicedesk-insight-object-types/src/common/utils/normalization/index.tsx';
import { createContainer } from '@atlassian/react-sweet-state';
import type { InsightObjectViewState, ContainerProps } from '../common/types/index.tsx';
import { fetchObjectViewInitialData } from '../controllers/store/actions/fetch-object-view-initial-data/index.tsx';
import { Store, type Actions } from '../controllers/store/index.tsx';
import { getHideEmptyAttributes } from '../services/hide-empty-attributes/index.tsx';

export const ObjectDetailsContainer = createContainer<
	InsightObjectViewState,
	Actions,
	ContainerProps
>(Store, {
	onInit:
		() =>
		({ setState, dispatch }, { initialObjectDetailsData }) => {
			setState({
				objectDetails: {
					...normalizeObjectDetailsResponse(initialObjectDetailsData),
					editableAttributeTypes: undefined,
				},
				hideEmptyAttributes: getHideEmptyAttributes(initialObjectDetailsData.objectType.id),
			});
			dispatch(fetchObjectViewInitialData());
		},
});
